<div class="" *ngIf="rootAssortment">
  <div
    class="header-wrapper image-container d-flex flex-column justify-content-center"
    [ngStyle]="getStyle(rootAssortment, '2000x1500')"
  >
    <div class="header-text" translate>PRODUCTS</div>
    <div>
      <a [routerLink]="['/products']" class="btn header-button" translate> PRODUCTS </a>
    </div>
  </div>

  <h1 class="mt-5 mb-4" translate>SELECT_CATEGORY</h1>
  <div class="row">
    <div class="col-12 col-md-6 col-xl-4 mb-4" *ngFor="let assortment of rootAssortment?.children">
      <div class="category-image" [routerLink]="['/categories/', assortment.id]" [ngStyle]="getStyle(assortment)">
        <div class="text-banner">
          {{ assortment.name }}
        </div>
      </div>
    </div>
  </div>
</div>
